import React from "react";
import "./DynamicTable.css";
import "./DynamicViewTable.css";
import Popup from "reactjs-popup";
import "./popup.css";
import { array } from "yup/lib/locale";

class DynamicViewTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      popup: false,
      idDelete: 0,
    };
    this.contentStyle = {
      maxWidth: "600px",
      width: "90%",
    };
    for (let i = 0; i < this.props.tableValues.length; i++) {
      let row = {};
      for (let tableItem of this.props.tableItems) {
        row[tableItem.name] = this.props.tableValues[i][tableItem.name];
      }
      this.state.rows.push(row);
    }
  }
  handleChange = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.state.rows];
    rows[idx][name] = value;
    this.setState({
      rows,
    });
    this.props.setPageStateByField("Items", this.state.rows);
  };
  handleAddRow = () => {
    const item = {};
    for (var tableItem of this.props.tableItems) {
      item[tableItem.name] = "";
    }
    this.setState({
      rows: [...this.state.rows, item],
    });
    this.props.setPageStateByField("Items", this.state.rows);
  };
  handleRemoveSpecificRow = (idx) => () => {
    console.log("Id", idx);
    const rows = [...this.props.pageStateArray];
    rows.splice(idx, 1);
    if (this.props.deleteEntryFromTableCallback != null) {
      this.props.deleteEntryFromTableCallback({ idx: idx, rows: rows });
      return;
    }
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  enablePopup = (idx) => {
    this.setState({ popup: true, idDelete: idx });
  };

  handleRemoveAllRow = () => () => {
    let dct = { rate_info: [] };
    this.props.setPageState({ ...this.props.pageState, ...dct });
  };

  handleEditSpecificRow = (idx) => () => {
    const rows = [...this.props.pageStateArray];
    let dct = rows[idx];
    if (this.props.fieldMapping == "rate_info") {
      dct.rate_info = rows;
      if (
        this.props.pageState.station_to != "" &&
        this.props.pageState.rate != ""
      ) {
        this.props.setPageMode("error");
        this.props.setPopupError("Clear Or Update existing Entry");
        return;
      }
      // rows.splice(idx, 1);
    } else {
      dct.charge_info = rows;
      if (
        this.props.pageState.other_station_to != "" &&
        this.props.pageState.amount != ""
      ) {
        this.props.setPageMode("error");
        this.props.setPopupError("Clear Or Update existing Entry");
        return;
      }
      // rows.splice(idx, 1);
    }
    rows.splice(idx, 1);

    if (this.props.fieldMapping == "rate_info") {
      console.log("DCT:- ", dct);
      dct.unit = dct.unit.toLowerCase();
      this.props.setPageState({ ...this.props.pageState, ...dct });
    } else {
      let newState = {};
      console.log("DCT:- new state ", dct);
      newState.other_station_to = dct.station_to;
      newState.other_station_to_name = dct.station_to_name;
      newState.other_station_from = dct.station_from;
      newState.other_station_from_name = dct.station_from_name;
      newState.other_item_name = dct.item_name;
      newState.other_item_id = dct.item_id;
      newState.consignee_name = dct.consignee_name;
      newState.consignee_id = dct.consignee_id;
      newState.charge = dct.charge;
      newState.charge_type = dct.charge_type;
      newState.from_c = String(parseInt(dct.qty_from_case) || 0);
      newState.to_c = String(parseInt(dct.qty_to_case) || 0);
      newState.from_w = String(parseInt(dct.qty_from_kg) || 0);
      newState.to_w = String(parseInt(dct.qty_to_kg) || 0);
      newState.amount = dct.amount;
      newState.charge_info = dct.charge_info;

      if (newState.consignee_id == null) {
        newState.consignee_id = "";
      }
      if (newState.consignee_name == null) {
        newState.consignee_name = "";
      }
      if (newState.from_c == "0") {
        newState.from_c = "";
      }
      if (newState.from_w == "0") {
        newState.from_w = "";
      }
      if (newState.to_c == "0") {
        newState.to_c = "";
      }
      if (newState.to_w == "0") {
        newState.to_w = "";
      }
      console.log("Only new state ", newState);
      this.props.setPageState({ ...this.props.pageState, ...newState });
    }

    if (this.props.deleteEntryFromTableCallback != null) {
      console.log("In delete entry");
      this.props.deleteEntryFromTableCallback({ idx: idx, rows: rows });
      return;
    }
    // this.props.setPageState({ ...this.props.pageState, ...dct });
    // this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  onKeyPress = (e, index, totalLength) => {
    // console.log(index, totalLength, e.key);
    if (index + 1 == totalLength && e.key == "Enter") {
      this.handleAddRow();
    }
  };

  selectAll = (arr) => {
    console.log("arr", arr.target.checked);
    if (arr.target.checked) {
      this.props.selectAll();
    } else {
      this.props.deselectAll();
    }
  };

  getItemValue = (fieldInfoObject, itemObject) => {
    //****CODE FOR SHOWING THE BALANCE IN THIR RESPECTIVE BALANCE TYPE****
    if (itemObject.party_name == "OPENING BALANCE") {
      if (itemObject.balance_type == "Dr") {
        itemObject.debit = itemObject.balance;
      } else if (itemObject.balance_type == "Cr") {
        itemObject.credit = itemObject.balance;
      }
    }
    // ****ENDS HERE****

    if ("convertFunction" in fieldInfoObject) {
      return fieldInfoObject.convertFunction(itemObject);
    } else {
      return itemObject[fieldInfoObject["name"]];
    }
  };

  render() {
    return (
      <div>
        <div>
          <Popup
            // trigger={<button className="button"> Open Modal </button>}
            open={this.state.popup}
            modal
            contentStyle={this.contentStyle}
            closeOnDocumentClick={false}
          >
            {(close) => (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  Are you sure want to delete entry?
                </div>
                {/* {myForm.pageMode == "submitted" ? (
                  <div className="pop-up-content">
                    {popupInfo.success_title}
                    <br />
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <div className="pop-up-field-label">
                          {popupInfo.field_label_success}
                        </div>
                        <div className="pop-up-field-value">
                          {myForm.pageState[popupInfo.field_name_success]}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="pop-up-content">
                    {popupInfo.error_title}
                    <br />
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <div className="pop-up-field-label">
                          {popupInfo.field_label_error}
                        </div>
                        <div className="pop-up-field-value">
                          {myForm.popupError}
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
                <div className="pop-up-actions">
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      console.log("id to delete", this.state.idDelete);
                      this.handleRemoveSpecificRow(this.state.idDelete)();
                      this.setState({ popup: false, idDelete: 0 });
                      close();
                    }}
                  >
                    Yes
                  </button>
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      console.log("id to delete", this.state.idDelete);
                      this.setState({ popup: false, idDelete: 0 });
                      close();
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
        <div className="dvt-container  responsive-table">
          <div className="row clearfix">
            <div className="col-md-12 column">
              <table
                className="table table-bordered table-hover"
                id="tab_logic"
              >
                <thead>
                  <tr>
                    {this.props.canView && <div></div>}
                    {process.env.REACT_APP_CLIENT === "bgtc" &&
                      this.props.formName === "Marfatiya" && (
                        <th className="text-center table-header"></th>
                    )}
                    {this.props.checkBox == 1 ? (
                      <th className="text-center table-header">
                        <div className="form-control-small-col">
                          <input
                            type="checkbox"
                            name="selectall"
                            checked={this.props.getSelectAllValue()}
                            onClick={(arr) => this.selectAll(arr)}
                          ></input>
                        </div>
                      </th>
                    ) : (
                      <th />
                    )}
                    {this.props.tableHeader.map((item) => (
                      <th className={item.className} key={item.label}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {this.props.tableValues.map((item, idx) => (
                    <tr id="addr0" key={idx}>
                      {this.props.canView && (
                        <button
                          onClick={() => this.props.handleViewClick(item)}
                        >
                          Open
                        </button>
                      )}

                      {process.env.REACT_APP_CLIENT === "bgtc" &&
                        this.props.formName === "Marfatiya" && (
                          <td className="text-center">
                            <button
                              className="item-remove-btn"
                              onClick={() => this.enablePopup(idx)}
                            >
                              -
                            </button>
                          </td>
                      )}

                      {this.props.checkBox == 0 ? (
                        <p />
                      ) : (
                        <td>
                          {this.props.checkBox == 1 ? (
                            <div>
                              <div className="form-control-small-col">
                                <input
                                  type="checkbox"
                                  name="chk"
                                  checked={item.checked == "1"}
                                  onChange={(arr) => {
                                    this.props.handleCheckboxChange(arr, item, idx);
                                  }}
                                />
                              </div>
                            </div>
                          ) : this.props.edit == 1 ? (
                            <button
                              className="item-edit-btn"
                              onClick={this.props.editRowFunction(
                                idx,
                                this.props.fieldMapping
                              )}
                            >
                              EDIT
                            </button>
                          ) : (
                            process.env.REACT_APP_CLIENT !== "shubham" && (
                              <button
                                className="item-remove-btn"
                                onClick={this.handleRemoveSpecificRow(idx)}
                                // onClick={() => this.enablePopup(idx)}
                              >
                                -
                              </button>
                            )
                          )}
                        </td>
                      )}

                      <td>
                        <div className="form-control-small-col">{idx + 1}</div>
                      </td>
                      {this.props.tableItems.map((row) => (
                        <>
                          <td key={idx + row.name}>
                            <div className={row.className}>
                              {process.env.REACT_APP_CLIENT === "bgtc" &&
                              row.name === "tempo_collection" ? (
                                <input
                                  style={{ width: "70px" }}
                                  value={item.tempo_collection || ""}

                                  disabled={
                                    this.props.pageMode !== "edit" ||
                                    (
                                      process.env.REACT_APP_CLIENT === "bgtc" &&
                                      this.props.formName === "Marfatiya" &&
                                      !(this.props.roleId === "1" || this.props.roleId === "2") &&
                                      item.isTempoSaved === true
                                    )
                                  }

                                  tabIndex={idx + 1}
                                  onChange={(e) => {
                                    const updatedRows = [...this.props.tableValues];
                                    updatedRows[idx] = {
                                      ...updatedRows[idx],
                                      tempo_collection: e.target.value,
                                    };
                                    this.props.setPageStateByField(
                                      this.props.fieldMapping,
                                      updatedRows
                                    );
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();

                                      const inputs = Array.from(
                                        document.querySelectorAll('input[tabindex]')
                                      );

                                      let nextIndex = idx + 1;

                                      //Skip disabled inputs
                                      while (
                                        inputs[nextIndex] &&
                                        inputs[nextIndex].disabled
                                      ) {
                                        nextIndex++;
                                      }

                                      if (inputs[nextIndex]) {
                                        inputs[nextIndex].focus();
                                      }
                                    }
                                  }}
                                />

                              ) : process.env.REACT_APP_CLIENT === "bgtc" &&
                                this.props.formName === "ConsignorBilling" &&
                                (row.name === "rate" || row.name === "item_amount" || row.name === "bill_remarks") ? (

                                <input
                                  style={{ width: row.name === "bill_remarks" ? "100px" : "65px", height: "25px",
                                          backgroundColor: "#d6d8d5", border: "none" }}
                                  value={item[row.name] ?? ""}
                                  onChange={(e) => {
                                    const updatedRows = [...this.props.tableValues];
                                    const value = e.target.value;
                                    const rowData = updatedRows[idx];

                                    if (row.name === "bill_remarks") {
                                      updatedRows[idx] = {
                                        ...rowData,
                                        checked: "1",
                                        edited: true,
                                        bill_remarks: value,
                                      };
                                    } else {
                                      const pkgs = parseFloat(rowData.pkgs || 0);
                                      const weight = parseFloat(rowData.weight || 0);
                                      const rate = parseFloat(value || 0);
                                      let total = parseFloat(rowData.item_amount || 0);

                                      if (row.name === "rate") {
                                        total = this.props.rate_type === "rate"
                                          ? pkgs * rate
                                          : weight * rate;

                                        updatedRows[idx] = {
                                          ...rowData,
                                          checked: "1",
                                          edited: true,
                                          rate: value,
                                          item_amount: Math.ceil(total),
                                        };
                                      }

                                      if (row.name === "item_amount") {
                                        updatedRows[idx] = {
                                          ...rowData,
                                          checked: "1",
                                          edited: true,
                                          item_amount: value,
                                        };
                                      }
                                    }

                                    const grossAmount = updatedRows.reduce((sum, r) => {
                                      if (r.checked === "1") {
                                        return sum + parseFloat(r.item_amount || 0);
                                      }
                                      return sum;
                                    }, 0);

                                    this.props.setPageStateByField(this.props.fieldMapping, updatedRows);
                                    this.props.setPageStateByField("gross_amount", Math.ceil(grossAmount));
                                  }}

                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      e.target.blur();
                                    }
                                  }}

                                  onBlur={() => {
                                    let rowToSave = this.props.tableValues[idx];

                                    if (row.name === "rate") {
                                      const currentRate = parseFloat(rowToSave?.rate || 0);
                                      const currentAmount = parseFloat(rowToSave?.item_amount || 0);

                                      if (currentRate && currentAmount === 0) {
                                        const pkgs = parseFloat(rowToSave?.pkgs || 0);
                                        const weight = parseFloat(rowToSave?.weight || 0);
                                        const recalculatedAmount = this.props.rate_type === "rate"
                                          ? pkgs * currentRate
                                          : weight * currentRate;

                                        rowToSave = {
                                          ...rowToSave,
                                          checked: "1",
                                          edited: true,
                                          item_amount: Math.ceil(recalculatedAmount),
                                        };

                                        const updatedRows = [...this.props.tableValues];
                                        updatedRows[idx] = rowToSave;

                                        const grossAmount = updatedRows.reduce((sum, r) => {
                                          if (r.checked === "1") {
                                            return sum + parseFloat(r.item_amount || 0);
                                          }
                                          return sum;
                                        }, 0);

                                        this.props.setPageStateByField(this.props.fieldMapping, updatedRows);
                                        this.props.setPageStateByField("gross_amount", Math.ceil(grossAmount));
                                      }
                                    }

                                    this.props.saveSingleRow(rowToSave);
                                  }}

                                />

                              ) : (

                                this.getItemValue(row, item)
                              )}
                            </div>
                          </td>
                        </>
                      ))}
                      {this.props.delete == 1 ? (
                        <td>
                          <button
                            className="item-delete-btn"
                            // onClick={this.handleRemoveSpecificRow(idx)}
                            onClick={() => this.enablePopup(idx)}
                          >
                            DELETE
                          </button>
                        </td>
                      ) : (
                        <td></td>
                      )}

                      {process.env.REACT_APP_CLIENT === "bgtc" &&
                        this.props.formName === "Marfatiya" &&
                        this.props.pageMode === "edit" &&
                        (
                          this.props.roleId === "1" ||
                          this.props.roleId === "2" ||

                          item.isTempoSaved === false
                        ) && (
                          <td className="text-center">
                            <button
                              className="item-edit-btn"
                              onClick={() => {
                                if (this.props.onSaveBiltyRow) {
                                  this.props.onSaveBiltyRow(item, idx);
                                }
                              }}
                            >
                              Save
                            </button>
                          </td>
                      )}
                    </tr>
                  ))}
                  {/* <tr>
                    <td>
                      <button
                        onClick={this.handleAddRow}
                        className="item-add-btn"
                      >
                        +
                      </button>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DynamicViewTable;
